import {
  createProtectedFileObjectUrl,
  downloadProtectedFile,
} from "./protectedFiles"

export type DocumentPrintLanguage = "pl" | "en"

const withPdfLang = (path: string, lang?: DocumentPrintLanguage): string => {
  if (!lang) return path
  const separator = path.includes("?") ? "&" : "?"
  return `${path}${separator}lang=${lang}`
}

export const previewDocumentPdf = async (
  path: string,
  fallbackFileName: string,
  lang?: DocumentPrintLanguage,
) => {
  const printLang = lang ?? "pl"
  const { objectUrl } = await createProtectedFileObjectUrl(
    withPdfLang(path, printLang),
    fallbackFileName,
  )

  window.open(objectUrl, "_blank", "noopener,noreferrer")

  window.setTimeout(() => {
    window.URL.revokeObjectURL(objectUrl)
  }, 60_000)
}

export const downloadDocumentPdf = async (
  path: string,
  fallbackFileName: string,
  lang?: DocumentPrintLanguage,
) => {
  const printLang = lang ?? "en"
  await downloadProtectedFile(withPdfLang(path, printLang), fallbackFileName)
}

export const previewPostedDocumentPdf = async (
  path: string,
  body: unknown,
  fallbackFileName: string,
  lang?: DocumentPrintLanguage,
) => {
  const printLang = lang ?? "pl"
  const { objectUrl } = await createProtectedFileObjectUrl(
    withPdfLang(path, printLang),
    fallbackFileName,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    },
  )

  window.open(objectUrl, "_blank", "noopener,noreferrer")

  window.setTimeout(() => {
    window.URL.revokeObjectURL(objectUrl)
  }, 60_000)
}

export const downloadPostedDocumentPdf = async (
  path: string,
  body: unknown,
  fallbackFileName: string,
  lang?: DocumentPrintLanguage,
) => {
  const printLang = lang ?? "en"
  await downloadProtectedFile(withPdfLang(path, printLang), fallbackFileName, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  })
}

export const previewMultipleDocumentPdfs = async (
  items: Array<{ path: string; fileName: string }>,
  lang?: DocumentPrintLanguage,
) => {
  for (const item of items) {
    await previewDocumentPdf(item.path, item.fileName, lang)
  }
}

export const downloadMultipleDocumentPdfs = async (
  items: Array<{ path: string; fileName: string }>,
  lang?: DocumentPrintLanguage,
) => {
  for (const item of items) {
    await downloadDocumentPdf(item.path, item.fileName, lang)
  }
}
